// Generated by Melange

import SliderModuleCss from "./slider.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = SliderModuleCss;

function Slider(Props) {
  let ariaLabelledby = Props.ariaLabelledby;
  let className = Props.className;
  let id = Props.id;
  let markers = Props.markers;
  let max = Props.max;
  let min = Props.min;
  let step = Props.step;
  let value = Props.value;
  let onValueChange = Props.onValueChange;
  const markersId = React.useId();
  let tmp = {
    className: Clsx(className, css.root),
    list: markersId,
    type: "range",
    onChange: (function ($$event) {
      if ($$event.defaultPrevented) {
        return;
      }
      const value = $$event.currentTarget.valueAsNumber;
      Stdlib__Option.iter((function (onValueChange) {
        Curry._1(onValueChange, value);
      }), onValueChange);
    })
  };
  if (ariaLabelledby !== undefined) {
    tmp["aria-labelledby"] = Caml_option.valFromOption(ariaLabelledby);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  const tmp$1 = Stdlib__Option.map((function (prim) {
    return String(prim);
  }), max);
  if (tmp$1 !== undefined) {
    tmp.max = Caml_option.valFromOption(tmp$1);
  }
  const tmp$2 = Stdlib__Option.map((function (prim) {
    return String(prim);
  }), min);
  if (tmp$2 !== undefined) {
    tmp.min = Caml_option.valFromOption(tmp$2);
  }
  if (step !== undefined) {
    tmp.step = Caml_option.valFromOption(step);
  }
  const tmp$3 = Stdlib__Option.map((function (prim) {
    return String(prim);
  }), value);
  if (tmp$3 !== undefined) {
    tmp.value = Caml_option.valFromOption(tmp$3);
  }
  const arg = null;
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("input", tmp),
      (function (param) {
        return Stdlib__Option.value(param, arg);
      })(Stdlib__Option.map((function (markers) {
        return JsxRuntime.jsx("datalist", {
          children: markers.map(function (marker) {
            const v = String(marker.value);
            return JsxRuntime.jsx("option", {
              label: marker.label,
              value: v
            }, v);
          }),
          id: markersId
        });
      }), Stdlib__Option.bind(markers, (function (markers) {
        if (markers.length === 0) {
          return;
        } else {
          return markers;
        }
      }))))
    ]
  });
}

const make = Slider;

export {
  make,
}
/* css Not a pure module */
